import { Link } from "gatsby";
import React from "react";

const Footer = () => {
  return (
    <footer className="mt-3 w-full bg-[#171717] px-6 pt-8 pb-10 lg:py-10 xl:px-24 2xl:px-36 space-y-6 2xl:space-y-8">
      <div className="space-y-8 lg:space-y-0 lg:flex lg:items-center lg:justify-between">
        <img src="/logoWhite.svg" alt="logo" />
        <ul className="space-y-4 text-base font-normal text-[#F2F2F2] lg:space-y-0 lg:flex gap-4 lg:items-center lg:justify-end xl:space-x-10 2xl:space-x-16">
          <li>
            <a href="/privacy" target='_blank'>Privacy Policy</a>
          </li>
          <li>
            <a href="/terms-of-use" target='_blank'>Terms of Use</a>
          </li>
          <li>
            <a href="/anti-money-laundering" target='_blank'>AML/CT Policy</a>
          </li>
        </ul>
      </div>
      <div className="space-y-4 text-base font-light text-[#F2F2F2] lg:space-y-0 lg:flex lg:items-center lg:justify-between">
        <p className="text-gray-100 font-extralight">© {new Date().getFullYear()} LocalRamp. All rights reserved</p>
        <a href="mailto:business@localramp.co">
          <span className="font-light text-gray-100">
            Contact us: <b> business@localramp.co</b>
          </span>
        </a>

        <div className="flex items-center justify-start space-x-2 text-[#F2F2F2]">
          <a href="https://twitter.com/localramp" target="_blank">
            <img src="/icons/twitter.svg" alt="twitter" className="w-5 h-5" />
          </a>
          <a href="https://www.linkedin.com/company/localramp" target="_blank">
            <img src="/icons/linkedin.svg" alt="linkedin" className="w-5 h-5" />
          </a>
          <p>@localramp</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
